import { gql } from '../../__generated__/gql'

export const COMMUNITY_REPORT_POST_MUTATION = gql(`
    mutation reportCommunityPost( $postId: Int!, $details: String! ) {
      reportCommunityPost(input: { postId: $postId, details: $details }) {
        clientMutationId
      }
    }
`)
